import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@obsn/shared/tokens.css";
import "./basis.css";
import { App } from "./App";
import { SitzungAnbieter } from "./kern/sitzung";
import { HinweisAnbieter } from "./kern/ui/Hinweise";
import { serviceWorkerAnmelden } from "./kern/push";

serviceWorkerAnmelden();

const root = document.getElementById("root");
if (!root) throw new Error("Element #root fehlt in index.html.");

const abfragen = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: 0 },
  },
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <SitzungAnbieter>
        <HinweisAnbieter>
          <App />
        </HinweisAnbieter>
      </SitzungAnbieter>
    </QueryClientProvider>
  </StrictMode>,
);
